/**
 * Componente bandeja de asistencias entrantes.
 * @module incomingAssistanceTrayController
 *
 * @param      {Object}  AssistanceService  Servicio para acciones sobre asistencias.
 * @param      {Object}  CatalogService     Servicio para recuperar catalogos.
 * @param      {Object}  $localForage       libreria para almacenamiento local.
 * @param      {Object}  toastr             Libreria para alertas.
 * @param      {Object}  toastrConfig       libreria para configuración de alertas.
 * @param      {Object}  $timeout       libreria para configuración de alertas.
 * @param      {Object}  $window       libreria para configuración de alertas.
 * @return     {Object}  Ctrl
 */
function incomingAssistanceTrayController(AssistanceService, CatalogService, $localForage, toastr, toastrConfig, $timeout, $window) {
	var vm = this;

	toastrConfig.positionClass = 'toast-top-center';

	/* Definicion de varibles */
	vm.assistances = [];
	vm.expediente = null;
	vm.craneList = []; // Contiene la lista de gruas disponibles para una asistencia
	vm.selected = {}; // Contiene el valor de la grúa seleccionada en el modal predictivo
	vm.selectedCrane = {}; // Contiene el valor de la grúa seleccionada en el modal geolocalizacion
	vm.dataReject = {}; // datos para modal rechazo
	vm.origin = [0, 0];
  vm.destination = [0, 0];
  vm.localAuctionId = '';
  vm.localAuctionService = [];

	/* Define funciones */
	vm.getIncomingAssistances = getIncomingAssistances;
	vm.takeAssistance = takeAssistance;
	vm.getCrane = getCrane;
	vm.setDataServiceR = setDataServiceR; // datos servicio modal rechazo
	vm.postRejectReason = postRejectReason; // envio razon de rechazo
	vm.setMapData = setMapData;
	vm.takeDirect = takeDirect;
	vm.localauction = localauction;
	vm.localauctionsave = localauctionsave;

	/* Inicializacion */
	vm.getIncomingAssistances(); // Obtiene asistencias entrantes asignadas

	vm.marker = [];
	vm.mapOptions = {
		center: [51.505, -0.09],
		zoom: 10,
		preferCanvas: false
	};
	var L = $window.L;
	var map = new L.map('mapvideowallincomming', vm.mapOptions);
	var layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
	// Adding layer to the map
	map.addLayer(layer);

	CatalogService.rejectReasons().then(function(data) {
		vm.rejectReasons = data.data.catalogueMotifsList;
	});
	// Prueba para notificaciones
/*
	vm.prueba = prueba;
	function prueba() {
		var time = 0;
		CatalogService.getCurrentDate().then(function(data) {
			time = data.data.timestamp;
			vm.newAssistance = angular.fromJson('{ "auction" : '+time+',"takenDate": 1549506077, "car": { "typeCar": "Jetta Clasico", "brandCar": "VW", "yearCar": "2006", "colorCar": "Blanco", "platesCar": "1234WQER", "rangehigh": "false", "rangetype": "AUTO" }, "service": { "code": "2", "des cription": "Siniestros", "id": "d83bad3f-a8a8-4607-84b6-42e0244bd9ba" }, "origin": { "postalCode": "3800", "state": "DISTRITO FEDERAL", "municipality": "ALVARO OBREGON", "neighborhood": "Los Alpes", "street": "Boulevard Adolfo López Mateos 223", "betweenStreets": "TEST", "visualReference": "TEST", "longitude": -99.197413720417, "latitude": 19.36526 }, "destination": { "postalCode": "3800", "state": "DISTRITO FEDERAL", "municipality": "ALVARO OBREGON", "neighborhood": "Los Alpes", "street": "Boulevard Adolfo López Mateos 223", "betweenStreets": "TEST", "visualReference": "TEST", "longitude": -99.197413720417, "latitude": 19.366526 }, "typeAssignment": { "code": "2", "description": "Publicacion", "id": "0097312b-cb65-4ba5-ac18-b8d60dfbeeec" }, "serviceDetails": { "placeEvent": "NO CARRETERO", "observations": "Sin info", "additionalInformation": "/ Entre Calles:TEST / Color del Auto:Amarillo/Dorado", "modification": "false", "reasonFailure": { "id": "0", "description": "NU no sabe", "code": "7" }, "typeGasoline": "null", "accompaniesTransfer": { "id": "0", "description": "Nuestro Usuario", "code": "1" }, "typeFaul": { "id": "0", "description": "MECANICA", "code": "1" }, "numberLiters": "null", "peopleVehicle": "1", "streetFoot": true, "garageParking": false, "parkingLevel": 0, "someCarFrontBehind": false, "hasCharge": false, "turnwheel":true, "struckOut":true, "inParking":true, "inNetral":true, "turnTires":true, "suspensionDamage":true, "tireDamage":true, "frontDamage":true, "rearDamage":true, "leftSideDamage":true, "authorityIntervened":true, "unitIsLocated":"CRUCERO", "moveTheUnit": "taller" }, "id": "11be3a97-2970-4ec1-a103-a35e1e253809", "subservice": { "code": "216", "description": "Grúas por Colisión", "id": "25b06e73-3aca-4c43-b814-b4421ffe635b" }, "status": { "code": "1", "description": "Abierto" }, "folio": "123123131", "typeService": "EMERGENCIA", "craneType": "PLATAFORMA" }');
			//vm.newAssistance = angular.fromJson('{"auction" : '+time+',"takenDate": 1549506077,"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":"AUTO"}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.19'+Math.floor(Math.random() * 10)+'7413720417, "latitude": 19.3'+Math.floor(Math.random() * 10)+'6526}, "destination":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.19'+Math.floor(Math.random() * 10)+'7413720417, "latitude": 19.36'+Math.floor(Math.random() * 10)+'6526}, "typeAssignment":{"code":"6", "description":"Subasta Local", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"placeEvent":"NO CARRETERO","observations":"Sin info", "additionalInformation":"/ Entre Calles:TEST / Color del Auto:Amarillo/Dorado", "modification":"false","reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1", "streetFoot":true,"garageParking":false,"parkingLevel":0,"someCarFrontBehind":false,"hasCharge":false}, "id":"11be3a97-2970-4ec1-a103-a35e1e253809'+Math.floor(Math.random() * 10)+'", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"},"folio":"'+Math.floor(Math.random() * 100000000)+'"}');
			// vm.newAssistance = angular.fromJson('{"auction" : '+time+',"takenDate": 1549506077,"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":""}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65","isAppointment":true,"appointmentDate":"1590107400"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.196'+Math.floor(Math.random() * 10)+'7413720417, "latitude": 19.35'+Math.floor(Math.random() * 10)+'6526}, "destination":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Destino-Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.196'+Math.floor(Math.random() * 10)+'7413720417, "latitude": 19.36'+Math.floor(Math.random() * 10)+'6526}, "typeAssignment":{"code":"1", "description":"Geolocalizada", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1"}, "id":"11be3a97-2970-4ec1-a103-a35e1e253809'+Math.floor(Math.random() * 10)+'", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"},"folio":"'+Math.floor(Math.random() * 100000000)+'"}');
			// vm.newAssistance = angular.fromJson('{"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":""}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "length": -99.19627413720417, "latitude": 19.3576526}, "typeAssignment":{"code":"1", "description":"Geolocalizada", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{	"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1"}, "id":"9a400020-49f3-4a06-97db-700e171054fc", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"}}');
			// vm.newAssistance = angular.fromJson('{"chatbot" : false,"auction" : '+time+',"takenDate": 1549506077,"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":""}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.196'+Math.floor(Math.random() * 10)+'7413720417, "latitude": 19.35'+Math.floor(Math.random() * 10)+'6526}, "typeAssignment":{"code":"1", "description":"Geolocalizada", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1"}, "id":"25d3e104-edda-45a1-84f1-fd73fcf7fd5c", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"},"folio":"'+Math.floor(Math.random() * 100000000)+'"}');
			// vm.chatBotQuestion = angular.fromJson('{"monitoreo" : {"question" : "Datos de Unidad Asignada?", "id" : "2"},"chatbot" : true, "typeAssignment":{"code":"0", "description":"Monitoreo", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "id":"f47aabb7-27d8-4034-be03-265beaa10c9'+Math.floor(Math.random() * 10)+'", "subservice":{"code":"0", "description":"Monitoreo", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"},"folio":"1666646'+Math.floor(Math.random() * 10)+'"}');
			// console.log(vm.assistanceInprogress);
			//var json = (vm.assistanceInprogress[Math.floor(Math.random() * (11 - 0 + 1) + 0)]);
			//if (json) {
			//	vm.chatBotQuestion = angular.fromJson('{"monitoreo" : {"question" : "Datos de Unidad Asignada?", "id" : "2"},"chatbot" : true, "typeAssignment":{"code":"0", "description":"Monitoreo"}, "id":"'+json.id+'", "subservice":{"code":"0", "description":"Monitoreo"}, "folio":"'+json.folio+'","type": "chatBot"}');
			//}
		});
		// vm.newAssistance = angular.fromJson('{"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":""}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "length": -99.19627413720417, "latitude": 19.3576526}, "typeAssignment":{"code":"1", "description":"Geolocalizada", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{	"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1"}, "id":"9a400020-49f3-4a06-97db-700e171054fc", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"}}');
	}

	vm.pruebadelete = pruebadelete;
	function pruebadelete() {
		var time = 0;
		CatalogService.getCurrentDate().then(function(data) {
			time = data.data.timestamp;
			vm.deleteChatBot = angular.fromJson('{"id" : "f47aabb7-27d8-4034-be03-265beaa10c91", "chatbot" : "true"}');
			console.log(vm.deleteChatBot);
		});
	}

*/

	/**
	 * { Se activa cuando las variables en el componente Tray sufren alguna modificacion
	 * por el canal y los diferentes tipos de mensajes }
	 */
	var incAssPrevious = null;
	var incAssPreviousChatbot = null;
	var relegatedPrevious = null;
	var deletePrevious = null;
	var deleteChatBoPrevious = null;
	var takePrevious = null;
	var updateAssistanceIncomingPrevious = null;
	var deleteChatPrevious = null;
	var audio = new Audio('../bower_components/audio/alert2.mp3');
	var audio2 = new Audio('../bower_components/audio/alert.mp3');
	this.$doCheck = function() {

		var incAssCurrent = vm.newAssistance;
		if (incAssPrevious !== incAssCurrent) {
			var diff = true;
			incAssPrevious = incAssCurrent;
			var pushAssistance = vm.assistances;
			for (var i in vm.assistances) {
				if (vm.assistances[i].id === vm.newAssistance.id) {
					diff = false;
				}
			}
			for (var a in vm.assistanceInprogress) {
				if (vm.assistanceInprogress[a].id === vm.newAssistance.id) {
					diff = false;
				}
			}
			if (diff) {
				pushAssistance.push(incAssCurrent);
				vm.assistances = pushAssistance.reverse();
				audio.play();
			}
		}
		/** notificacion chat bot */
		var incAssCurrentChatbot = vm.chatBotQuestion;
		if (incAssPreviousChatbot !== incAssCurrentChatbot) {
			incAssPreviousChatbot = incAssCurrentChatbot;
			var pushAssistance1 = vm.assistances;
			var diff1 = true;
			for (var o in vm.assistances) {
				if (vm.assistances[o].id === incAssCurrentChatbot.id) {
					diff1 = false;
				}
			}
			/*
			for (var u in vm.assistanceInprogress) {
				if (vm.assistanceInprogress[u].id === incAssCurrentChatbot.id && vm.assistanceInprogress[u].bot !== null) {
					console.log(vm.assistanceInprogress[u]);

					console.log("Asistencias en progreso existe");
					diff1 = false;
				}
			} */
			if (diff1) {
				pushAssistance1.push(incAssCurrentChatbot);
				vm.assistances = pushAssistance1.reverse();
				audio2.play();
			}
		}

		var relegatedCurrent = vm.relegatedAssistance;
		if (relegatedPrevious !== relegatedCurrent) {
			relegatedPrevious = relegatedCurrent;
			var getNodo = getOneAssistanceOfList(relegatedCurrent.assistance);
			if (getNodo) {
				getNodo.typeAssignment = relegatedCurrent.typeAssignmented;
			}
		}

		var deleteCurrent = vm.deleteAssistance;
		if (deletePrevious !== deleteCurrent) {
			deletePrevious = deleteCurrent;
			$('#' + deleteCurrent.id).modal('hide');
			deleteOneAssistanceList(deleteCurrent.id);
			$('#gruaModal').modal('hide');
            $('#predictivoGruaModal').modal('hide');
		}


		var deleteChatCurrent = vm.flagDetailChatBot;
		if (deleteChatPrevious !== deleteChatCurrent) {
			deleteChatPrevious = deleteChatCurrent;
			var res = _.filter(vm.assistances, function(o) {
				return o.id !== vm.flagDetailChatBot && o.chatbot === true;
			});
			vm.assistances = res;
		}
		var deleteChatBotCurrent = vm.deleteChatBot;
		if (deleteChatBoPrevious !== deleteChatBotCurrent) {
			deleteChatBoPrevious = deleteChatBotCurrent;
			var res1 = _.filter(vm.assistances, function(o) {
				return o.id !== deleteChatBotCurrent.id && o.chatbot === true;
			});
			vm.assistances = res1;
		}

		var takeCurrent = vm.isTake;
		if (takePrevious !== takeCurrent) {
			takePrevious = takeCurrent;
			deleteOneAssistanceList(takeCurrent.id);
		}

		var updateAssistanceIncomingCurrent = vm.updateAssistanceIncoming;
		if (updateAssistanceIncomingPrevious !== updateAssistanceIncomingCurrent) {
			var getNodoUpdate = getOneAssistanceOfList(updateAssistanceIncomingCurrent.id);
			if (getNodoUpdate) {
				// getNodoUpdate.agreement = updateAssistanceIncomingCurrent.agreement;
				getNodoUpdate.origin = updateAssistanceIncomingCurrent.origin;
				// getNodoUpdate.destination = updateAssistanceIncomingCurrent.destination;
				// getNodoUpdate.appointment = updateAssistanceIncomingCurrent.appointment;
				// getNodoUpdate.relevant = updateAssistanceIncomingCurrent.relevant;
				getNodoUpdate.car = updateAssistanceIncomingCurrent.car;
				getNodoUpdate.serviceDetails = updateAssistanceIncomingCurrent.serviceDetails;
				// getNodoUpdate.user = updateAssistanceIncomingCurrent.user;
			}
			updateAssistanceIncomingPrevious = updateAssistanceIncomingCurrent;
		}
	};

	/* Implementacion */
	/** @static
	 * @function
	 * @name getOneAssistanceOfList
	 * @description Ayuda para obtener una asistencia de la lista existente
	 * @param      {string}  idAssistance    id de asistencia
	 * @return	{Object | undefined}	nodoAssistance	Datos de una asistencia
	 */
	function getOneAssistanceOfList(idAssistance) {
		var nodoAssistance = _.find(vm.assistances, function(o) {
			return o.id === idAssistance;
		});
		return nodoAssistance;
	}
	/** @static
	 * @function
	 * @name deleteOneAssistanceList
	 * @description Ayuda para eliminar una asistencia de la lista existente
	 * @param      {string}  idAssistance    id de asistencia
	 * @return {void}
	 */
	function deleteOneAssistanceList(idAssistance) {
		var res = _.filter(vm.assistances, function(o) {
				return o.id !== idAssistance;
			});
		vm.assistances = res;
	}
	/** @static
		* @function
		* @name getIncomingAssistances
		* @description Obtiene lista de asistencias activas al hacer login.
	  * @return {void}
		*/
	function getIncomingAssistances() {
		$localForage.getItem('dataUser').then(function(data) {
			AssistanceService.getIncomingAssistances(data.id, 'active').then(function (data) {
				vm.assistances = data.data.assistanceInformationList;
				/**
				var nueva = '{"data":{"data":{"assistanceInformationList": [{"car":{"typeCar":"Jetta Clasico","brandCar":"VW", "yearCar":"2006", "colorCar":"Blanco", "platesCar":"1234WQER",	"rangehigh":"false","rangetype":""}, "service":{"code":"1", "description":"Asistencia Vial", "id":"81485957-cff2-4db0-8722-12c666d23b65"}, "origin":{"postalCode":"3800", "state":"DISTRITO FEDERAL", "municipality":"ALVARO OBREGON","neighborhood":"Los Alpes", "street":"Boulevard Adolfo López Mateos 223","betweenStreets":"TEST", "visualReference":"TEST", "longitude": -99.19627413720417, "latitude": 19.3576526}, "typeAssignment":{"code":"1", "description":"Geolocalizada", "id":"fccb8653-5c86-440e-a544-c406c6397b35"}, "serviceDetails":{"reasonFailure":{"id":"0", "description":"NU no sabe","code":"7"}, "typeGasoline":"null", "accompaniesTransfer":{	"id":"0", "description":"Nuestro Usuario","code":"1"}, "typeFaul":{"id":"0", "description":"MECANICA","code":"1"}, "numberLiters":"null","peopleVehicle":"1"}, "id":"9a400020-49f3-4a06-97db-700e171054fc", "subservice":{"code":"211", "description":"Arrastre de Grúa", "id":"f2c193e7-8517-4c16-a5e3-deb0944fc78b"}, "status":{"code":"1", "description":"Abierto"}}]},"errors": [],"isSuccess": "true","success": "null"}}';
				var json = angular.fromJson(nueva);
				vm.assistances = json.data.data.assistanceInformationList;
				console.log(vm.assistances);
				*/
			});
		});
	}
	/** @static
		* @function
		* @name takeAssistance
	  * @param {Object} crane - Datos de la grúa para asignación de asistencia.
		* @description Envia datos de una asistencia para ser tomada por el usuario.
	  * @return {void}
		*/
	function takeAssistance(crane) {
		var dataCrane = null;
		vm.selected = {}; // limpia el valor seleccionado
		vm.selectedCrane = {};
		if (angular.isString(crane)) {
			dataCrane = angular.fromJson(crane);
		} else {
			dataCrane = crane;
		}

		if (dataCrane.id) {
			$localForage.getItem('dataUser').then(function(data) {
				var cEta = dataCrane.eta ? dataCrane.eta : 0;
				AssistanceService.takeAssistance(data.id, vm.expediente.id, {craneId : dataCrane.id, typeAssignment : vm.expediente.typeAssignment.code, eta : cEta.toString()}).then(function(data) {
					if (data.isSuccess === true) {
						toastr.success('Asistencia asignada!', 'Asistencia!');
					} else {
						var msg = data.data.dsError;
						toastr.error(msg, 'Asistencia!');
					}
					deleteOneAssistanceList(vm.expediente.id);
				});
			});
		} else {
			toastr.error('Seleccione una grua', 'Información!');
		}
		$('#gruaModal').modal('hide');
		$('#predictivoGruaModal').modal('hide');
		$('#'+vm.expediente.id).modal('hide');
	}
	/** @static
		* @function
		* @name getCrane
	  * @param {Object} expedient - Datos de asistencia.
		* @description Envia datos de proveedor y asistencia para consultar lista de gruas.
	  * En caso de ser geolocalizada se usa la descripcion que se agrega en el nodo como selectDescription para mostarlo en la vista
	  * @return {void}
		*/
	function getCrane(expedient) {
        vm.selectedCrane = null;
        vm.craneList = null;
		$localForage.getItem('dataUser').then(function(data) {
			vm.expediente = expedient;
			AssistanceService.getCraneList(data.id, expedient.id).then(function(data) {
				// pruebas listado de gruas geo
				// data = angular.fromJson('{"isSuccess":true,"success":null,"errors":[],"data":{"cranesList":[{"id":"ed7b7c95-f046-40bb-a9ab-b3ca1aee3d92","clEconomic":"10","clCrane":"1731","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NEM9255","lastUpdate":"2020-07-17 18:00:29.692","latitude":"-98.94698","longitude":"-98.94698","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"58a77d68-571a-4dd9-ae3e-6a25100805d4","clEconomic":"14","clCrane":"2927","clType":"11","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"1W9KL","lastUpdate":"2019-12-23 16:04:03.534","latitude":"-98.94695","longitude":"-98.94695","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"e16453d6-d889-4ca9-a615-954da94d2070","clEconomic":"15","clCrane":"3045","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"DBU05","lastUpdate":"2020-08-05 15:55:04.578","latitude":"-98.232704","longitude":"-98.232704","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"0cae59a1-8a9f-4243-9846-083a4868f16f","clEconomic":"1","clCrane":"322","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"5F2JF","lastUpdate":"2020-08-02 17:26:43.784","latitude":"-99.09972","longitude":"-99.09972","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"a9c87364-b633-4c57-b307-20d69c1ba9d9","clEconomic":"18","clCrane":"3048","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NNA4478","lastUpdate":"2020-07-31 15:39:52.481","latitude":"-99.26839","longitude":"-99.26839","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"f903daef-4756-40d2-82ea-ffce7596ec66","clEconomic":"3","clCrane":"324","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NAM2724","lastUpdate":"2020-03-20 00:00:33.82","latitude":"-98.94704","longitude":"-98.94704","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"5bebe09e-bc6e-4937-99f1-d9371e7a9eb5","clEconomic":"11","clCrane":"1732","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MKP4113","lastUpdate":"2020-08-05 00:55:11.775","latitude":"-99.03191","longitude":"-99.03191","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"8d837afa-2d06-435f-8b94-05cb6167533a","clEconomic":"7","clCrane":"328","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"G28JS","lastUpdate":"2020-08-04 21:35:44.463","latitude":"-99.14304","longitude":"-99.14304","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"bde5dd42-1279-41ce-9a57-82ab0a445e5a","clEconomic":"4","clCrane":"325","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MPL7806","lastUpdate":"2020-06-25 20:39:43.732","latitude":"-98.94706","longitude":"-98.94706","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"0f720104-a0c7-4ff9-a8cf-e2152874df90","clEconomic":"8","clCrane":"329","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MWD3007","lastUpdate":"2020-08-05 02:16:29.372","latitude":"-99.0318","longitude":"-99.0318","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"89d87674-4eba-4131-8d9b-35bfed634a74","clEconomic":"6","clCrane":"327","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MAE9878","lastUpdate":"2020-06-29 16:23:56.52","latitude":"-98.989","longitude":"-98.989","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"e98ce5dd-068e-414d-af92-1fa99fc55ee1","clEconomic":"17","clCrane":"3047","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"A27AUL","lastUpdate":"2020-07-24 20:10:35.822","latitude":"-98.180305","longitude":"-98.180305","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"16213ae7-83fa-44a3-baea-abef1b12e704","clEconomic":"2","clCrane":"323","clType":"11","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"2EJNR","lastUpdate":"2020-08-03 19:08:48.637","latitude":"-99.03916","longitude":"-99.03916","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"1c9e88dd-44dc-4952-b06b-d700bbb1b1f7","clEconomic":"12","clCrane":"1733","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NGF3392","lastUpdate":"2020-08-05 15:32:10.684","latitude":"-99.14096","longitude":"-99.14096","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"9e566d43-fa63-497a-98f7-4ca469fba381","clEconomic":"5","clCrane":"326","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"8140K","lastUpdate":"2020-06-28 16:27:17.48","latitude":"-99.03193","longitude":"-99.03193","type":"MOTO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"7207b7cd-411b-4a01-80d9-4df13c6ee5be","clEconomic":"13","clCrane":"2926","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"JAR1046","lastUpdate":"2020-08-05 14:53:46.142","latitude":"-99.049644","longitude":"-99.049644","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"c6e43e62-8cc4-4a1c-9abd-23075dfaaf00","clEconomic":"16","clCrane":"3046","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"UAR1046","lastUpdate":"2020-08-01 17:37:17.121","latitude":"-98.94703","longitude":"-98.94703","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""},{"id":"666f4860-2794-4d84-b55a-f5d065580bdc","clEconomic":"9","clCrane":"330","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"156YCA","lastUpdate":"2020-08-05 01:45:58.625","latitude":"-99.14185","longitude":"-99.14185","type":"AUTO UTILITARIO","eta":"'+Math.floor(Math.random() * 100)+'","distance":""}]}}');
				// pruebas listado de gruas pub
				// data = angular.fromJson('{"isSuccess":true,"success":null,"errors":[],"data":{"cranesList":[{"id":"ed7b7c95-f046-40bb-a9ab-b3ca1aee3d92","clEconomic":"10","clCrane":"1731","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NEM9255","lastUpdate":"2020-07-17 18:00:29.692","latitude":"-98.94698","longitude":"-98.94698","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"58a77d68-571a-4dd9-ae3e-6a25100805d4","clEconomic":"14","clCrane":"2927","clType":"11","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"1W9KL","lastUpdate":"2019-12-23 16:04:03.534","latitude":"-98.94695","longitude":"-98.94695","type":"MOTO","eta":"","distance":""},{"id":"e16453d6-d889-4ca9-a615-954da94d2070","clEconomic":"15","clCrane":"3045","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"DBU05","lastUpdate":"2020-08-05 15:55:04.578","latitude":"-98.232704","longitude":"-98.232704","type":"MOTO","eta":"","distance":""},{"id":"0cae59a1-8a9f-4243-9846-083a4868f16f","clEconomic":"1","clCrane":"322","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"5F2JF","lastUpdate":"2020-08-02 17:26:43.784","latitude":"-99.09972","longitude":"-99.09972","type":"MOTO","eta":"","distance":""},{"id":"a9c87364-b633-4c57-b307-20d69c1ba9d9","clEconomic":"18","clCrane":"3048","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NNA4478","lastUpdate":"2020-07-31 15:39:52.481","latitude":"-99.26839","longitude":"-99.26839","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"f903daef-4756-40d2-82ea-ffce7596ec66","clEconomic":"3","clCrane":"324","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NAM2724","lastUpdate":"2020-03-20 00:00:33.82","latitude":"-98.94704","longitude":"-98.94704","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"5bebe09e-bc6e-4937-99f1-d9371e7a9eb5","clEconomic":"11","clCrane":"1732","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MKP4113","lastUpdate":"2020-08-05 00:55:11.775","latitude":"-99.03191","longitude":"-99.03191","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"8d837afa-2d06-435f-8b94-05cb6167533a","clEconomic":"7","clCrane":"328","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"G28JS","lastUpdate":"2020-08-04 21:35:44.463","latitude":"-99.14304","longitude":"-99.14304","type":"MOTO","eta":"","distance":""},{"id":"bde5dd42-1279-41ce-9a57-82ab0a445e5a","clEconomic":"4","clCrane":"325","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MPL7806","lastUpdate":"2020-06-25 20:39:43.732","latitude":"-98.94706","longitude":"-98.94706","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"0f720104-a0c7-4ff9-a8cf-e2152874df90","clEconomic":"8","clCrane":"329","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MWD3007","lastUpdate":"2020-08-05 02:16:29.372","latitude":"-99.0318","longitude":"-99.0318","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"89d87674-4eba-4131-8d9b-35bfed634a74","clEconomic":"6","clCrane":"327","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"MAE9878","lastUpdate":"2020-06-29 16:23:56.52","latitude":"-98.989","longitude":"-98.989","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"e98ce5dd-068e-414d-af92-1fa99fc55ee1","clEconomic":"17","clCrane":"3047","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"A27AUL","lastUpdate":"2020-07-24 20:10:35.822","latitude":"-98.180305","longitude":"-98.180305","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"16213ae7-83fa-44a3-baea-abef1b12e704","clEconomic":"2","clCrane":"323","clType":"11","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"2EJNR","lastUpdate":"2020-08-03 19:08:48.637","latitude":"-99.03916","longitude":"-99.03916","type":"MOTO","eta":"","distance":""},{"id":"1c9e88dd-44dc-4952-b06b-d700bbb1b1f7","clEconomic":"12","clCrane":"1733","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"0","plaque":"NGF3392","lastUpdate":"2020-08-05 15:32:10.684","latitude":"-99.14096","longitude":"-99.14096","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"9e566d43-fa63-497a-98f7-4ca469fba381","clEconomic":"5","clCrane":"326","clType":"11","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"MOTO","active":"1","busy":"0","plaque":"8140K","lastUpdate":"2020-06-28 16:27:17.48","latitude":"-99.03193","longitude":"-99.03193","type":"MOTO","eta":"","distance":""},{"id":"7207b7cd-411b-4a01-80d9-4df13c6ee5be","clEconomic":"13","clCrane":"2926","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"JAR1046","lastUpdate":"2020-08-05 14:53:46.142","latitude":"-99.049644","longitude":"-99.049644","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"c6e43e62-8cc4-4a1c-9abd-23075dfaaf00","clEconomic":"16","clCrane":"3046","clType":"10","imei":"logout","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"UAR1046","lastUpdate":"2020-08-01 17:37:17.121","latitude":"-98.94703","longitude":"-98.94703","type":"AUTO UTILITARIO","eta":"","distance":""},{"id":"666f4860-2794-4d84-b55a-f5d065580bdc","clEconomic":"9","clCrane":"330","clType":"10","imei":"login","brand":"","model":"","sim":"","phone":"","descriptionCrane":"AUTO UTILITARIO","active":"1","busy":"3","plaque":"156YCA","lastUpdate":"2020-08-05 01:45:58.625","latitude":"-99.14185","longitude":"-99.14185","type":"AUTO UTILITARIO","eta":"","distance":""}]}}');
				if (data.isSuccess) {
					if (data.data.cranesList.length > 0) {
						vm.craneList = _.orderBy(data.data.cranesList, [
							function (v) {
								return Number(v.eta);
							}], ['asc']);
						_.forEach(vm.craneList, function(item) { // Agrega descripcion para select
							item.selectDescription = 'No. ' + item.clEconomic + ' : ' + item.eta + 'min. ' + item.descriptionCrane + ', Placa: ' + item.plaque;
						});
						vm.selectedCrane = _.head(_.orderBy(_.uniqBy(vm.craneList, 'eta'), [
							function (v) {
								return Number(v.eta);
							}], ['asc']));// Selecciona la grúa con menor ETA
					} else {
						vm.selectedCrane = null;
						vm.craneList = null;
						$('#gruaModal').modal('hide');
						$('#predictivoGruaModal').modal('hide');
						$('#' + expedient.id).modal('hide');
						toastr.info(data.data.message, 'Información!');
					}
				} else {
					vm.craneList = null;
					$('#gruaModal').modal('hide');
					$('#predictivoGruaModal').modal('hide');
					$('#' + expedient.id).modal('hide');
					toastr.error(data.data.message, 'Información!');
				}
			});
		});
	}
	/** @static
	* @function
	* @name getCrane
	* @param {Object} expedient - Datos de asistencia.
	* @description Envia datos de proveedor y asistencia para consultar lista de gruas.
	* En caso de ser geolocalizada se usa la descripcion que se agrega en el nodo como selectDescription para mostarlo en la vista
	* @return {void}
	*/
	function takeDirect(expedient) {
		$localForage.getItem('dataUser').then(function(data) {
			AssistanceService.takeAssistanceOneClick(data.id, expedient.id, {typeAssignment : expedient.typeAssignment.code}).then(function(data) {
				if (data.isSuccess === true) {
					toastr.success('Asistencia asignada!', 'Asistencia!');
				} else {
					toastr.error(data.data.dsError, 'Asistencia!');
				}
				deleteOneAssistanceList(expedient.id);
			});
		});
	}

	/** @static
		* @function
		* @name setDataServiceR
		* @description Asigna el id de la asistencia.
	  * @param {String}  id  Id de asistencia.
	  * @return {void}
		*/
	function setDataServiceR(id) { // funciones de rechazo
		vm.dataReject.idService = id;
	}
	/** @static
		* @function
		* @name postRejectReason
		* @description Rechazo de una asistencia.
	  * @return {void}
		*/
	function postRejectReason() {
		$localForage.getItem('dataUser').then(function(data) {
			vm.dataReject.idProvider = data.id;
			if (vm.dataReject.reason) {
				AssistanceService.postRejectReason(vm.dataReject).then(function(data) {
					if (data.isSuccess === true) {
						deleteOneAssistanceList(data.data.id);
						toastr.success('Asistencia rechazada!', 'Rechazo!');
					} else {
						toastr.error('Falla al rechazar el servicio!', 'Rechazo!');
					}
					vm.dataReject = {};
				});
			} else {
				toastr.error('Seleccione motivo de rechazo!', 'Rechazo!');
			}
			$('#rejectServiceModal').modal('hide');
			$('#' + vm.dataReject.idService).modal('hide');
		});
	}

	/**
	 * @static
	 * @function
	 * @name setMapData
	 * @description  Asigna valores para mostar en mapa y logica para marker de destino.
	 * @param      {Array}   origin       The origin
	 * @param      {Array}   destination  The destination
	 * @return  {void} void
	 */
	function setMapData(origin, destination) {
		remove();
		markersmap(origin, 'icon-person-pin', 'Origen');
		markersmap(destination, 'icon-pin-drop', 'Destino');
		// map.setView(new L.LatLng(origin.latitude, origin.longitude), 17);
		var group = new L.featureGroup(vm.marker);
		var bounds = group.getBounds().extend(group.getBounds());
		map.fitBounds(bounds);
		$timeout(function() {
			map.invalidateSize();
		}, 200);

		// vm.origin = [origin.latitude, origin.longitude];
		// vm.destination = [destination.latitude, destination.longitude];
	}
		/**
	 * @static
	 * @function
	 * @name markersmap
	 * @description Genera markers.
	 * @param {Object} temp informacion de grua
	 * @param {String} icon tipo de icono a mostrar
	 * @param {String} message mensaje a mostrar
	 * @return  {void} Asigna el resultado a la variable de vm.assistances
	 */
	function markersmap(temp, icon, message) {
		// icon-towing
		var myIcon = L.divIcon({
				className: '',
				iconSize: null,
				html:'<i class="' + icon + '" style="font-size: 400%; color:black; ">'
				});
		var latlng = [temp.latitude, temp.longitude];

		var markerOptions = {
				title : message,
				clickable : false,
				draggable : false,
				icon : myIcon,
				customId : temp
		};
		vm.marker.push(L.marker(latlng, markerOptions).addTo(map));
	}
	/**
	 * @static
	 * @function
	 * @name remove
	 * @description Reconstruye div de asistencias .
	 * @return  {void} Asigna el resultado a la variable de vm.assistances
	 */
	function remove() {
		// Remove a marker
		vm.marker.forEach(function(a) {
				map.removeLayer(a);
		});
		vm.marker = [];
	}
	/** @static
	* @function
	* @name localauction
	* @param {Object} service - body servicio.
	* @param {Object} assistanceId - id asistencia.
	* @description Envia datos de proveedor y asistencia para consultar lista de gruas.
	* En caso de ser geolocalizada se usa la descripcion que se agrega en el nodo como selectDescription para mostarlo en la vista
	* @return {void}
	*/
	function localauction(service, assistanceId) {
		vm.localAuctionId = assistanceId;
		vm.localAuctionService = service;
		$('#localAuction').modal('show');
	}
	/** @static
	* @function
	* @name localauctionsave
	* @description Envia datos de proveedor y asistencia para consultar lista de gruas.
	* En caso de ser geolocalizada se usa la descripcion que se agrega en el nodo como selectDescription para mostarlo en la vista
	* @return {void}
	*/
	function localauctionsave() {

		if(vm.newAssistance.serviceDetails.placeEvent==='CARRETERO'){
			var costos = vm.localAuctionService.costs;
			var arryCostos = costos.split('|');
			var beginning_trip = arryCostos[0].split('-')[1];
			var kilometers_traveled = arryCostos[1].split('-')[1];

			var request  ={
				"beginning_trip": parseInt(beginning_trip),
				"kilometers_traveled": parseInt(kilometers_traveled),
				"toll_booths": 0,
				"wait_time": 0,
				"iva": 0,
				"contact_time": vm.localAuctionService.estimatedTime,
				"comments": vm.localAuctionService.comments
			};
			$localForage.getItem('dataUser').then(function(data) {
				AssistanceService.auction(data.id, vm.localAuctionId, request).then(function(data) {
					if (data.isSuccess === true) {
						toastr.success('Cotizacion enviada!', 'Envio correcto!');
						$('#' + id).modal('hide');
					} else {
						toastr.error('Falla al enviar cotizacion!', 'Cotización!');
					}
					vm.dataReject = {};
				});
			});
		}else if(vm.newAssistance.serviceDetails.placeEvent==='NO CARRETERO')	{
			$localForage.getItem('dataUser').then(function(data) {
				AssistanceService.localAcutionCost(data.id, vm.localAuctionId, vm.localAuctionService).then(function(response) {
				if (response.isSuccess === true) {
					toastr.success('Cotizacion enviada!', 'Envio correcto!');
					$('#' + vm.localAuctionId).modal('hide');
				} else {
					toastr.error('Falla al enviar cotizacion!', 'Cotización!');
				}
				});
			});
		}



	}


} // end controller


/**
 * @namespace timeHelperController
 * @desc Ayuda para acciones en la vista de detalle.
 * @memberOf Factories
 *
 * @param      {Object}  AssistanceService    Servicio para envio de cotizacion.
 * @param      {Object}  $localForage         Libreria para almacenamiento local.
 * @param      {Object}  toastr               Libreria para alertas.
 * @param      {Object}  toastrConfig         Libreria para configuración de alertas.
 * @return 		 {Object}	 Ctrl
 */
function timeHelperController(AssistanceService, $localForage, toastr, toastrConfig) {
	toastrConfig.positionClass = 'toast-top-center';
	var vm = this;


	vm.auction = auction;

	vm.dif = 0;
	vm.res = {beginning_trip : '', kilometers_traveled : 0, toll_booths : 0, wait_time : 0, iva : 0, contact_time : ''};

	vm.iva = false;
	vm.ivac = 0;
	vm.comments = '';
	vm.getData = {};

	/**
	 * @static
	 * @function
	 * @name auction
	 * @description  validainformacion de asistencias y envio.
	 * @param      {Array}   id       identificador de asistencia
	 * @return  {void} void
	 */
	function auction(id) {
		var assistanceid = id;
		var error = true;
		vm.res.iva = 0;
		if (vm.dif > 0) {
			_.forEach(vm.res, function (value, index) {
				if ((value === null || angular.isUndefined(value) || value === '' || value === 0) && index !== 'comments' && index !== 'toll_booths' && index !== 'iva' && index !== 'wait_time' && index !== 'kilometers_traveled') {
					error = false;
				}
			});
			if (vm.iva) {
				vm.res.iva = vm.ivac;
			}
			vm.res.comments = vm.comments;
			if (error) {
				$localForage.getItem('dataUser').then(function(data) {
					AssistanceService.auction(data.id, assistanceid, vm.res).then(function(data) {
						if (data.isSuccess === true) {
							toastr.success('Cotizacion enviada!', 'Envio correcto!');
							$('#' + id).modal('hide');
						} else {
							toastr.error('Falla al enviar cotizacion!', 'Cotización!');
						}
						vm.dataReject = {};
					});
				});
			} else {
				toastr.info('Todos los campos deben tener costos capturados, igual o mayor a cero', 'Cotización!');
				vm.error = true;
			}
		} else {
			toastr.info('Termino el tiempo de subasta', 'Cotización!');
			vm.error = true;
			$('#' + id).modal('hide');
		}
	}
}
angular
	.module('app')
	.component('incomingAssistanceTray', {
		templateUrl: 'app/components/incomingAssistanceTray/incomingAssistanceTray.html',
		controller: incomingAssistanceTrayController,
		controllerAs : 'ctrl',
		bindings : {
			assistanceInprogress : '=',
			cardsWidthIncoming : '=',
			newAssistance : '<',
			relegatedAssistance : '<',
			deleteAssistance : '<',
			isTake : '<',
			updateAssistanceIncoming : '<',
			chatBotQuestion : '=',
			flagDetailChatBot : '=',
			deleteChatBot : '=',
			data : '='
		}
	})
	.controller('timeHelperController', timeHelperController);


